<template>
  <v-card :class="$style.modalWrapper"
          @click.stop>
    <v-content :class="$style.modalContentContainer">
      <v-layout :class="$style.modalContent"
                align-center
                justify-center
                column
                fill-height>
        <div :class="$style.logo">
          <Logo/>
        </div>
        <h3 v-if="title"
            :class="$style.title"
        >
          {{ title }}
        </h3>
        <slot />
      </v-layout>
    </v-content>
  </v-card>
</template>

<script>
import Logo from '@/components/Logo';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  components: { Logo },
  props:      {
    title: {
      type:    String,
      default: '',
    },
  },
})

export default class MobileSimpleModalContainer extends Vue {}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";

.modalContent {
  padding: 20px 30px 30px;
}
.logo {
  max-width: 169px;
  margin-bottom: 9px;
}

.title {
  font-family: 'LP Bambus', sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: $black;
  text-align: center;
  margin: 15px 0 20px;
}

@media screen and (width: 1080px) {
  .modalContent {
    padding: 75px 20px;
  }

  .logo {
    max-width: 320px;
    margin-bottom: 63px;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/MobileSimpleModalContainer.vue